/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Passkeys_UnavailableInputs */

const en_error_passkeys_unavailable = /** @type {(inputs: Error_Passkeys_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkeys aren't available right now. Use another way to sign in.`)
};

/**
* | output |
* | --- |
* | "Passkeys aren't available right now. Use another way to sign in." |
*
* @param {Error_Passkeys_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_passkeys_unavailable = /** @type {((inputs?: Error_Passkeys_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Passkeys_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_passkeys_unavailable(inputs)
});